import { axios, organizationIdConfig } from '../configs';
import { TSignedUrl } from '../types';

const getSignUrl = async (
  body: {
    filename: string;
    contentType: string;
    size: number;
  },
  organizationId?: number | null,
): Promise<TSignedUrl> => {
  return await axios
    .post('upload/signed-url', body, organizationIdConfig(organizationId))
    .then((response) => {
      return response.data;
    });
};

const uploadFile = async (
  preSignedUrl: string,
  file: File,
  contentType?: string,
) => {
  const res = await fetch(preSignedUrl, {
    method: 'PUT',
    body: file,
    headers: contentType ? { 'Content-Type': contentType } : undefined,
  });
  if (!res.ok) {
    console.error(res);
    throw new Error(res.statusText);
  }
  return res;
};

export { getSignUrl, uploadFile };
